import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Popover } from '@material-ui/core';
import { MdDelete, MdEdit, MdAdd, MdVisibility } from 'react-icons/md';
import { FaChartLine } from 'react-icons/fa';

import Paper from 'components/Paper';
import { LoadingPage } from 'components/Loading';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import { Row } from 'styles/components';
import NaturezasActions from 'store/ducks/naturezas';

import {
  Container,
  WrapperTable,
  WrapperAdd,
  DeleteIcon,
  EditIcon,
  ViewIcon,
  WrapperPopover,
  PopoverText,
  PopoverButton,
  TipoBadge,
  ClassificacaoBadge,
} from './styles';

function Naturezas() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { naturezas, isLoading } = useSelector((state) => state.naturezas);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [search, setSearch] = useState('');

  const data = naturezas.map((item) => ({
    ...item,
    actions: item.id,
    id: item.id,
    codigo: item.codigo || '-',
    codigoPai: item.codigoPai || '-',
    descricao: item.descricao || '-',
    tipo: item.tipo,
    classificacao: item.classificacao,
  }));

  const filteredData = data.filter(
    (item) =>
      (item.codigo || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.descricao || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.codigoPai || '').toUpperCase().includes(search.toUpperCase())
  );

  useEffect(() => {
    dispatch(NaturezasActions.getNaturezasRequest());
  }, [dispatch]);

  if (isLoading) {
    return <LoadingPage />;
  }

  const handleDelete = () => {
    if (selectedId) {
      dispatch(NaturezasActions.removeNaturezaRequest(selectedId));
      setOpen(false);
      setAnchorEl(null);
    }
  };

  const handleEdit = (id) => {
    history.push(`/financeiro/naturezas/edit/${id}`);
  };

  const handleView = (id) => {
    history.push(`/financeiro/naturezas/view/${id}`);
  };

  const getTipoBadge = (tipo) => {
    const tipoMap = {
      Sintetica: { label: 'Sintética', color: '#2196F3' },
      Analitica: { label: 'Analítica', color: '#FF9800' },
    };
    const tipoInfo = tipoMap[tipo] || tipoMap.Sintetica;
    return (
      <TipoBadge color={tipoInfo.color}>{tipoInfo.label}</TipoBadge>
    );
  };

  const getClassificacaoBadge = (classificacao) => {
    const classificacaoMap = {
      Receita: { label: 'Receita', color: '#4CAF50' },
      Despesa: { label: 'Despesa', color: '#F44336' },
    };
    const classificacaoInfo = classificacaoMap[classificacao] || classificacaoMap.Receita;
    return (
      <ClassificacaoBadge color={classificacaoInfo.color}>
        {classificacaoInfo.label}
      </ClassificacaoBadge>
    );
  };

  return (
    <Container>
      <Paper
        title="NATUREZAS"
        icon={<FaChartLine size={24} style={{ color: '#122d58', marginRight: '25px' }} />}
        rightContent={
          <Row>
            <SearchInput
              onChange={(e) => setSearch(e.target.value)}
              onClear={() => setSearch('')}
              value={search}
            />
            <WrapperAdd>
              <div
                onClick={() => history.push('/financeiro/naturezas/new')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  height: '36px',
                  minWidth: '120px',
                  padding: '0 20px',
                  backgroundColor: '#FFF28D',
                  boxShadow: '0px 3px 6px #00000029',
                  borderRadius: '3px',
                  fontSize: '12px',
                  fontWeight: 600,
                  color: '#122d58',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = '0.9';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = '1';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <MdAdd size={20} style={{ marginRight: '10px', color: '#122d58' }} />
                Nova Natureza
              </div>
            </WrapperAdd>
          </Row>
        }
      >
        <WrapperTable>
          <Table
            columns={[
              { label: 'Ações', id: 'actions' },
              { label: 'Código', id: 'codigo' },
              { label: 'Código Pai', id: 'codigoPai' },
              { label: 'Descrição', id: 'descricao' },
              { label: 'Tipo', id: 'tipo' },
              { label: 'Classificação', id: 'classificacao' },
            ]}
            activePage={0}
            totalPages={Math.ceil(filteredData.length / 10)}
            data={filteredData}
            customComponent={{
              actions: (id) => (
                <Row>
                  <ViewIcon
                    onClick={() => handleView(id)}
                    style={{ marginRight: '10px' }}
                  />
                  <EditIcon
                    onClick={() => handleEdit(id)}
                    style={{ marginRight: '10px' }}
                  />
                  <DeleteIcon
                    onClick={(e) => {
                      setSelectedId(id);
                      setAnchorEl(e.currentTarget);
                      setOpen(true);
                    }}
                  />
                </Row>
              ),
              tipo: (tipo) => getTipoBadge(tipo),
              classificacao: (classificacao) => getClassificacaoBadge(classificacao),
            }}
          />
        </WrapperTable>
      </Paper>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => {
          setOpen(false);
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <WrapperPopover>
          <PopoverText>Tem certeza que deseja excluir?</PopoverText>
          <Row>
            <PopoverButton onClick={handleDelete}>Sim</PopoverButton>
            <PopoverButton
              onClick={() => {
                setOpen(false);
                setAnchorEl(null);
              }}
            >
              Não
            </PopoverButton>
          </Row>
        </WrapperPopover>
      </Popover>
    </Container>
  );
}

export default Naturezas;

